"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgCheckOut = function SvgCheckOut(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    stroke: "#4D4D4D",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.393v7.775m0 0 3.393-3.393m-3.394 3.393-3.393-3.393m9.667 2.648v-8.65l-6.255-4.39H8l-6.256 4.39v8.65"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgCheckOut);
var _default = Memo;
exports["default"] = _default;